import { Approvals, initialState, FiltersHttpStatus } from './approvals.state';
import { ApprovalsActions, ApprovalsActionType } from './approvals.actions';

import * as Objects from '@core/objects';
import * as Search from '@app/models/search';
import { VersionFeedback } from '@core/models/version-feedback';

export function approvalsReducer(state = initialState, action: ApprovalsActions): Approvals {
    switch (action.type) {
		// EVENTS STATUS
        case ApprovalsActionType.Clear:
            return {
                ...state, 
                starting: initialState.starting, 
                available_filters: initialState.available_filters,
                search: initialState.search,
                search_query_params: initialState.search_query_params,
                results: initialState.results,
                feedbacks: initialState.feedbacks,
                events: []
            };
        
        case ApprovalsActionType.ResetFeedbacks:
            // emty feedbacks each time we change the search
            return {
                ...state, 
                feedbacks: initialState.feedbacks
            };

        case ApprovalsActionType.Init:
            let term = action.params!=null? action.params.term : "";
            let params = {...action.params};

            return {
                ...state,
                starting: {
                    ...state.starting,
                    initialized: true
                },
                search_query_params: action.params,
                search: {
                    ...state.search, term: term
                },
                feedbacks: {...state.feedbacks, feedbackAccess: action.feedbackAccess, globalAccess: action.approvalsGlobalAccess },
            };

        case ApprovalsActionType.LoadFilterLabels: 
            return {...state, available_filters: {...state.available_filters, 
                    initialized_status: {...state.available_filters.initialized_status, 
                        labels: { 
                            status: FiltersHttpStatus.LOADING } 
                        }
                    }
                };
        case ApprovalsActionType.LoadFilterUsers: 
            return {...state, available_filters: {...state.available_filters, 
                    initialized_status: {...state.available_filters.initialized_status, 
                        users: { 
                            status: FiltersHttpStatus.LOADING } 
                        }
                    }
                };
    

        case ApprovalsActionType.LoadFilterLabelsSuccess:
            return {...state, available_filters: {...state.available_filters, 
                labels: {...state.available_filters.labels, items: action.labels },
                initialized_status: {...state.available_filters.initialized_status, 
                    labels: {...state.available_filters.initialized_status.labels, 
                        status: FiltersHttpStatus.DONE 
                        } 
                    }
                
                }
            };

        case ApprovalsActionType.LoadFilterLabelsError:
            return {...state, available_filters: {...state.available_filters, 
                initialized_status: {...state.available_filters.initialized_status, 
                    labels: {...state.available_filters.initialized_status.labels, 
                        status: FiltersHttpStatus.ERROR 
                        } 
                    }
                }
            };

        case ApprovalsActionType.LoadFilterUsersSuccess:
            return {...state, available_filters: {...state.available_filters,
                users: {...state.available_filters.users, items: action.users },
                initialized_status: {...state.available_filters.initialized_status, 
                    users: {...state.available_filters.initialized_status.users, 
                        status: FiltersHttpStatus.DONE 
                        }                         
                    }
                }
            };

        case ApprovalsActionType.LoadFilterUsersError:
            return {...state, available_filters: {...state.available_filters, 
                initialized_status: {...state.available_filters.initialized_status, 
                    users: {...state.available_filters.initialized_status.users, 
                        status: FiltersHttpStatus.ERROR 
                        } 
                    }
                }
        };
        case ApprovalsActionType.LoadFilterUsersErrorNoResponse:
            return {...state, available_filters: { ...state.available_filters,
                initialized_status: {
                    ...state.available_filters.initialized_status,
                    users: {...state.available_filters.initialized_status.users, 
                        status: FiltersHttpStatus.TIMEOUT 
                        } 
                    }
                }
            };

        case ApprovalsActionType.PushSearchFilters:
            let filters = action.filters.filter((e: Search.SearchAppliedFilter) => !state.search.filters.some((ef: Search.SearchAppliedFilter)=> ef.key == e.key && ef.item.id == e.item.id));
            return {...state, search: {...state.search, filters: [...state.search.filters, ...filters]}};

        case ApprovalsActionType.ApplySearchFilter:

            return {...state, search: {...state.search, filters: [...state.search.filters, action.filter] }};

        case ApprovalsActionType.RemoveSearchFilter:
            return {...state, search: {...state.search, filters: state.search.filters.filter((f: Search.SearchAppliedFilter) => !(f.key == action.filter.key && f.item.id == action.filter.item.id)) }};

        case ApprovalsActionType.SetSearchTerm:
            return {...state, search: {...state.search, term: action.term}};

        case ApprovalsActionType.SetQueryParams:
            // reset page also
            
            return {...state, search_query_params: action.params, results: {...state.results, completed_items: [],uncompleted_items: [], next_page_completed: 1, next_page_uncompleted: 1, status: {uncompleted: Search.SearchHttpStatus.INITIAL, completed: Search.SearchHttpStatus.INITIAL} }};

        case ApprovalsActionType.LoadCompletedResults:
            return {...state, results: {...state.results, status: {...state.results.status, completed: Search.SearchHttpStatus.LOADING }}};
        
        case ApprovalsActionType.LoadUncompletedResults:
            return {...state, results: {...state.results, status: {...state.results.status, uncompleted: Search.SearchHttpStatus.LOADING }}};

        case ApprovalsActionType.LoadUncompletedResultsSuccess:
            let uncompletedStatus = action.versions.length < state.search.limit? Search.SearchHttpStatus.FINAL : Search.SearchHttpStatus.DONE;
            switch(state.results.next_page_uncompleted ) {
                case 1:
                    return {
                        ...state,
                        results: {
                            ...state.results,
                            uncompleted_items: action.versions,
                            next_page_uncompleted: 2,
                            status: {...state.results.status, uncompleted: uncompletedStatus},
                        },
                        events: []
                    };
                default:
                    return {
                        ...state,
                        results: {
                            ...state.results,
                            uncompleted_items: [...state.results.uncompleted_items.filter((er: Objects.Version) => !action.versions.some((eer: Objects.Version) => eer.id == er.id)), ...action.versions],
                            next_page_uncompleted: state.results.next_page_uncompleted + 1,
                            status: {...state.results.status, uncompleted: uncompletedStatus},
                        }
                    };
            }
        case ApprovalsActionType.LoadCompletedResultsSuccess:
            let completedStatus = action.versions.length < state.search.limit? Search.SearchHttpStatus.FINAL : Search.SearchHttpStatus.DONE;
            switch(state.results.next_page_completed ) {
                case 1:
                    return {
                        ...state,
                        results: {
                            ...state.results,
                            completed_items: action.versions,
                            next_page_completed: 2,
                            status: {...state.results.status, completed: completedStatus},
                        },
                        events: []
                    };
                default:
                    return {
                        ...state,
                        results: {
                            ...state.results,
                            completed_items: [...state.results.completed_items.filter((er: Objects.Version) => !action.versions.some((eer: Objects.Version) => eer.id == er.id)), ...action.versions],
                            next_page_completed: state.results.next_page_completed + 1,
                            status: {...state.results.status, completed: completedStatus},
                        }
                    };
            }
        case ApprovalsActionType.LoadUncompletedResultsFeedbacks:
            if (state.feedbacks.feedbackAccess != null && state.feedbacks.feedbackAccess == false){
                return state;
            }
        
            return {...state, feedbacks:  {
                ...state.feedbacks,
                    status : {...state.results.status, uncompleted: Search.SearchHttpStatus.LOADING }
                }
            }

        case ApprovalsActionType.LoadCompletedResultsFeedbacks:
            if (state.feedbacks.feedbackAccess != null && state.feedbacks.feedbackAccess == false){
                return state;
            }
        
            return {...state, feedbacks:  {
                ...state.feedbacks,
                    status : {...state.results.status, completed: Search.SearchHttpStatus.LOADING }
                }
            }

        case ApprovalsActionType.LoadUncompletedResultsFeedbacksSuccess:
            switch(state.results.next_page_uncompleted ) {
                case 1:
                    return {...state, feedbacks:  {
                        ...state.feedbacks,  
                            uncompleted: action.feedbacks,
                            status : {...state.results.status, uncompleted: Search.SearchHttpStatus.DONE }
                        }
                    }
                default:
                    return {
                        ...state, 
                        feedbacks: {
                            ...state.feedbacks , 
                            uncompleted: 
                                [...state.feedbacks.uncompleted.filter((f: VersionFeedback) => !action.feedbacks.some((vf: VersionFeedback) => (f.version.id == vf.version.id) )), ...action.feedbacks],
                            status : {...state.results.status, uncompleted: Search.SearchHttpStatus.DONE }
                        }
                    };
            }
        case ApprovalsActionType.LoadCompletedResultsFeedbacksSuccess:
            switch(state.results.next_page_completed ) {
                case 1:
                    return {...state, feedbacks:  {
                        ...state.feedbacks,  
                            completed: action.feedbacks,
                            status : {...state.results.status, completed: Search.SearchHttpStatus.DONE }
                        }
                    }
                default:
                    return {
                        ...state, 
                        feedbacks: {
                            ...state.feedbacks , 
                            completed: 
                                [...state.feedbacks.completed.filter((f: VersionFeedback) => !action.feedbacks.some((vf: VersionFeedback) => (f.version.id == vf.version.id) )), ...action.feedbacks],
                            status : {...state.results.status, completed: Search.SearchHttpStatus.DONE }
                        }
                    };
            }
        case ApprovalsActionType.UpdateVersion:
            return {
                ...state,
                events: [...[{id: action.versionId, name: action.eventName}], ...state.events]
            };
        case ApprovalsActionType.UpdateVersionSuccess:
            return {
                ...state,
                results: {
                    ...state.results,
                    uncompleted_items: [...state.results.uncompleted_items.filter((er: Objects.Version) => er.id != action.versionId), ...action.versions],
                    completed_items: [...state.results.completed_items.filter((er: Objects.Version) => er.id != action.versionId), ...action.versions],
                }
            };

        case ApprovalsActionType.ReloadResults:
            return {...state, results: {...state.results, next_page_completed: 1, next_page_uncompleted: 1}};
        
        case ApprovalsActionType.UpdateResultItemsStatus:
            return {...state, results: {...state.results, selected_status: action.status}};

        // SEARCH ERRORS
        /**
         * Set an ERROR search status for general errors and a NOT ACCEPTABLE for 406 error (Search.SearchHttpStatusCode.NOT_ACCEPTABLE)
         */
        case ApprovalsActionType.LoadCompletedResultsError:
            return {...state,
                results: {
                    ...state.results,
                    status: {...state.results.status, completed: action.error.status != Search.SearchHttpStatusCode.NOT_ACCEPTABLE ? Search.SearchHttpStatus.ERROR : Search.SearchHttpStatus.NOT_ACCEPTABLE },
                },
                events: []
            };
        case ApprovalsActionType.LoadUncompletedResultsError:
            return {...state,
                results: {
                    ...state.results,
                    status: {...state.results.status, uncompleted: action.error.status != Search.SearchHttpStatusCode.NOT_ACCEPTABLE ? Search.SearchHttpStatus.ERROR : Search.SearchHttpStatus.NOT_ACCEPTABLE },
                },
                events: []
            };
        default:
           return state;
    }
}
